<template>
    <div class="header">
        <div class="login-status" @click="loginInfo">
            <img v-if="isLogin" src="@/assets/images/header/logged.png" class="logged" />
            <p v-else class="login-text">登录/注册</p>
        </div>
        <a :href="getDynamicURLWithContext('../prd/home')" class="logo">
            <img height="100%" src="@/assets/images/logo/sf-logo.png" alt="首页logo" />
        </a>
        <div class="logo-switch">
            <img class="switch" src="@/assets/images/header/three-line.png" alt="菜单" @click="toggleNav" />
        </div>
        <transition name="fade">
            <div v-show="showNav" class="wrap-nav">
                <div class="navs">
                    <a :href="getDynamicURLWithContext('../prd/home')" class="navs-logo">
                        <img height="100%" src="@/assets/images/logo/sf-logo.png" alt="首页logo" />
                    </a>
                    <img src="@/assets/images/header/close.png" alt="关闭" @click="setShowNav(false)" />
                </div>
                <submenu :list="menus" class="menus" />
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ajax from '../../api/ajax'
import { getDynamicURLWithContext } from '@/util/util'
import MenuConfig from './menuConfig'
import getOnlineService from '@/mixins/onlineService/index'
import submenu from './components/submenu'
export default {
    components: {
        submenu
    },
    data() {
        return {
            showMore: false,
            MenuConfig,
            menus: []
        }
    },
    async created() {
        const res = await ajax.getHomeMenus()
        if (res && res.headerMenu) {
            this.menus = res.headerMenu
        }
    },
    computed: {
        ...mapState(['title', 'isLogin', 'region', 'lang', 'showNav'])
    },
    methods: {
        getDynamicURLWithContext,
        ...mapMutations(['setShowNav']),
        toggleNav() {
            const isShow = this.showNav ^ true
            this.setShowNav(isShow)
        },
        loginInfo() {
            if (this.isLogin) {
                this.$router.push({ name: 'user' })
            } else {
                this.$router.push({ name: 'login' })
            }
        },
        // 登出
        logout() {
            ajax.logout().then(() => {
                this.$router.push({ name: 'login' })
            })
        },
        async onlineConsult() {
            const url = await getOnlineService()
            window.open(url, '_blank')
        }
    },
    watch: {
        $route(to, from) {
            this.setShowNav(false)
        }
    }
}
</script>
<style lang="scss" scoped>
.header {
    padding: 0 12px 0 20px;
    z-index: 20;
    min-height: 88px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.logo {
    height: 0.56rem;
    img {
        width: 0.56rem;
        height: 100%;
    }
}
.title {
    font-size: 39px;
}

.logo-switch {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
        width: 48px;
        height: auto;
    }
}
.login-status {
    height: 100%;
    display: flex;
    height: 100%;
    align-items: center;
    .logged {
        height: 48px;
        width: auto;
    }
    .login-text {
        color: #0a0f16;
        font-size: 24px;
        font-weight: 600;
        white-space: nowrap;
    }
}
.login-status,
.logo-switch {
    flex-basis: 100px;
}
.wrap-nav {
    overflow: auto;
    position: fixed;
    left: 0;
    top: 0px;
    width: 100%;
    z-index: 1000;
    background-color: #fff;
    height: 100%;
    padding: 0 18px 0 24px;
    .navs {
        height: 88px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .navs-logo {
            display: inline-flex;
            img {
                height: 56px;
                width: 56px;
            }
        }

        > img {
            height: 48px;
            width: 48px;
            position: relative;
            left: 6px;
        }
    }
}
.menus {
    background: #fff;
    padding-bottom: 30px;
    .icon-close {
        display: inline-block;
        vertical-align: middle;
        width: 0.36rem;
        height: 0.36rem;
        position: relative;
        bottom: 0;
        background: url('~@/assets/images/ico/icon-close.png') center / cover;
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.6s;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue